var _rect, _circle, _circle2, _circle3, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseViewerSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 209,
    viewBox: "0 0 111 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.428791,
    y: 0.428791,
    width: 109.638,
    height: 208.142,
    rx: 21.0108,
    stroke: "#404041",
    strokeWidth: 0.857582
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2036,
    cy: 179.436,
    r: 12.1347,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.203,
    cy: 179.435,
    r: 11.8944,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2031,
    cy: 179.437,
    r: 13.2326,
    stroke: "#404041",
    strokeWidth: 1.71516,
    strokeDasharray: "1.72 1.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3038 10.6166L15.9388 13.3799H16.0022L17.6452 10.6166H19.5811L17.1067 14.6706L19.6365 18.7246H17.665L16.0022 15.9573H15.9388L14.276 18.7246H12.3124L14.8501 14.6706L12.3599 10.6166H14.3038Z",
    fill: "#404041"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1645_508)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-1_1645_508",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 18,
    width: 26,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 18,
    width: 26,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0252 19C14.7107 19 13.645 20.0656 13.645 21.3801V33.4546L13.6312 33.4144C13.2033 32.1716 11.8488 31.5109 10.6059 31.9389C9.36299 32.3669 8.70236 33.7213 9.13032 34.9642L12.9187 45.9664C12.9712 46.1191 13.0378 46.263 13.1164 46.3971C13.1968 51.1431 17.0691 54.9656 21.8342 54.9656C26.9506 54.9656 31.0983 50.8179 31.0983 45.7015V42.3774C31.0983 42.3537 31.0981 42.33 31.0978 42.3063C31.098 42.2948 31.0981 42.2832 31.0981 42.2716V34.8668C31.0981 33.6984 30.1509 32.7512 28.9825 32.7512C27.8302 32.7512 26.8932 33.6722 26.8673 34.8182V33.2806C26.8673 32.1122 25.9201 31.1649 24.7517 31.1649C23.5832 31.1649 22.636 32.1122 22.636 33.2806V36.4535H22.635V31.6931C22.635 30.5247 21.6878 29.5774 20.5194 29.5774C19.3784 29.5774 18.4484 30.4806 18.4053 31.611V21.3801C18.4053 20.0656 17.3397 19 16.0252 19Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0252 19C14.7107 19 13.645 20.0656 13.645 21.3801V33.4546L13.6312 33.4144C13.2033 32.1716 11.8488 31.5109 10.6059 31.9389C9.36299 32.3669 8.70236 33.7213 9.13032 34.9642L12.9187 45.9664C12.9712 46.1191 13.0378 46.263 13.1164 46.3971C13.1968 51.1431 17.0691 54.9656 21.8342 54.9656C26.9506 54.9656 31.0983 50.8179 31.0983 45.7015V42.3774C31.0983 42.3537 31.0981 42.33 31.0978 42.3063C31.098 42.2948 31.0981 42.2832 31.0981 42.2716V34.8668C31.0981 33.6984 30.1509 32.7512 28.9825 32.7512C27.8302 32.7512 26.8932 33.6722 26.8673 34.8182V33.2806C26.8673 32.1122 25.9201 31.1649 24.7517 31.1649C23.5832 31.1649 22.636 32.1122 22.636 33.2806V36.4535H22.635V31.6931C22.635 30.5247 21.6878 29.5774 20.5194 29.5774C19.3784 29.5774 18.4484 30.4806 18.4053 31.611V21.3801C18.4053 20.0656 17.3397 19 16.0252 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.645 33.4546L12.6995 33.7802L14.645 33.4546H13.645ZM13.6312 33.4144L12.6857 33.74L12.6857 33.74L13.6312 33.4144ZM10.6059 31.9389L10.2803 30.9934H10.2803L10.6059 31.9389ZM9.13032 34.9642L8.1848 35.2898L8.1848 35.2898L9.13032 34.9642ZM12.9187 45.9664L13.8642 45.6409L13.8642 45.6409L12.9187 45.9664ZM13.1164 46.3971L14.1162 46.3802L14.1118 46.1179L13.9792 45.8916L13.1164 46.3971ZM31.0978 42.3063L30.098 42.2903L30.0977 42.3042L30.0979 42.3181L31.0978 42.3063ZM26.8673 34.8182H25.8673L27.8671 34.8408L26.8673 34.8182ZM22.636 36.4535V37.4535H23.636V36.4535H22.636ZM22.635 36.4535H21.635V37.4535H22.635V36.4535ZM18.4053 31.611H17.4053L19.4046 31.6491L18.4053 31.611ZM14.645 21.3801C14.645 20.6179 15.2629 20 16.0252 20V18C14.1584 18 12.645 19.5133 12.645 21.3801H14.645ZM14.645 33.4546V21.3801H12.645V33.4546H14.645ZM12.6857 33.74L12.6995 33.7802L14.5906 33.129L14.5767 33.0889L12.6857 33.74ZM10.9314 32.8844C11.6521 32.6363 12.4375 33.0193 12.6857 33.74L14.5767 33.0889C13.969 31.3238 12.0454 30.3856 10.2803 30.9934L10.9314 32.8844ZM10.0758 34.6387C9.82768 33.918 10.2108 33.1326 10.9314 32.8844L10.2803 30.9934C8.51523 31.6011 7.57703 33.5247 8.1848 35.2898L10.0758 34.6387ZM13.8642 45.6409L10.0758 34.6387L8.1848 35.2898L11.9732 46.292L13.8642 45.6409ZM13.9792 45.8916C13.9339 45.8142 13.8951 45.7306 13.8642 45.6409L11.9732 46.292C12.0474 46.5076 12.1417 46.7117 12.2536 46.9026L13.9792 45.8916ZM21.8342 53.9656C17.6157 53.9656 14.1874 50.5815 14.1162 46.3802L12.1165 46.4141C12.2062 51.7047 16.5225 55.9656 21.8342 55.9656V53.9656ZM30.0983 45.7015C30.0983 50.2656 26.3983 53.9656 21.8342 53.9656V55.9656C27.5029 55.9656 32.0983 51.3702 32.0983 45.7015H30.0983ZM30.0983 42.3774V45.7015H32.0983V42.3774H30.0983ZM30.0979 42.3181C30.0981 42.3378 30.0983 42.3576 30.0983 42.3774H32.0983C32.0983 42.3498 32.0981 42.3221 32.0978 42.2945L30.0979 42.3181ZM30.0981 42.2716C30.0981 42.2778 30.0981 42.2841 30.098 42.2903L32.0977 42.3224C32.098 42.3055 32.0981 42.2886 32.0981 42.2716H30.0981ZM30.0981 34.8668V42.2716H32.0981V34.8668H30.0981ZM28.9825 33.7512C29.5986 33.7512 30.0981 34.2507 30.0981 34.8668H32.0981C32.0981 33.1461 30.7032 31.7512 28.9825 31.7512V33.7512ZM27.8671 34.8408C27.8807 34.2369 28.375 33.7512 28.9825 33.7512V31.7512C27.2855 31.7512 25.9056 33.1076 25.8676 34.7957L27.8671 34.8408ZM25.8673 33.2806V34.8182H27.8673V33.2806H25.8673ZM24.7517 32.1649C25.3678 32.1649 25.8673 32.6644 25.8673 33.2806H27.8673C27.8673 31.5599 26.4724 30.1649 24.7517 30.1649V32.1649ZM23.636 33.2806C23.636 32.6644 24.1355 32.1649 24.7517 32.1649V30.1649C23.0309 30.1649 21.636 31.5599 21.636 33.2806H23.636ZM23.636 36.4535V33.2806H21.636V36.4535H23.636ZM22.635 37.4535H22.636V35.4535H22.635V37.4535ZM21.635 31.6931V36.4535H23.635V31.6931H21.635ZM20.5194 30.5774C21.1355 30.5774 21.635 31.0769 21.635 31.6931H23.635C23.635 29.9724 22.2401 28.5774 20.5194 28.5774V30.5774ZM19.4046 31.6491C19.4273 31.0537 19.9179 30.5774 20.5194 30.5774V28.5774C18.8389 28.5774 17.4696 29.9075 17.406 31.5729L19.4046 31.6491ZM17.4053 21.3801V31.611H19.4053V21.3801H17.4053ZM16.0252 20C16.7874 20 17.4053 20.6179 17.4053 21.3801H19.4053C19.4053 19.5133 17.8919 18 16.0252 18V20Z",
    fill: "black",
    mask: "url(#path-6-outside-1_1645_508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1645_508",
    x: 3.99976,
    y: 16,
    width: 32.0984,
    height: 45.9658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1645_508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1645_508",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseViewerSvg);
export default __webpack_public_path__ + "static/media/Close ViewerSVG.9bcb01b5888873abfa4fe0ffcb82a34e.svg";
export { ForwardRef as ReactComponent };